import {until} from 'lit-html/directives/until';

const renderGroup = async (group, groupIndex, ctx, html) => {
  const tier = await group.tier;
  return html`
    <div class="mb-5 mr-lg-5">
      <div><strong><label for="group-${group.tier}" class="col-form-label"><span aria-hidden="true">*</span>${until(group.tier)}</label></strong></div>
      <div class="d-flex">
        <select class="form-control form-control-sm ${ctx.parentId === 0 && groupIndex === (ctx.groups.length - 1) ? 'is-invalid': ''}" id="group-${group.tier}" name="${group.tier}" @change="${(e) => ctx.selectGroup(e, groupIndex)}" ?disabled="${ctx.disabled}">
          <option disabled selected>${until(ctx.__('<tt-65bwdnFP>', 'Select', 'Select Classes, Select District, ...'))} ${tier}</option>
          ${group.groups.map((item, itemIndex) => html`
            ${item.id > 0 ? html`
            <option value="${itemIndex}" .selected="${group.selected === item.id}">${item.name}</option>
            ` : html ``}
          `)}
        </select>
      </div>
      <div>
        ${ctx.parentId === 0 && groupIndex === (ctx.groups.length - 1) ? html`
          <p class="invalid-feedback d-block mb-0">
            ${until(ctx._r(ctx.__('<tt-18yN7vvf>', 'Please select a %r1%'), tier))}
          </p>
        `: ''}
      </div>
  </div>
`;
};

export default (ctx, html) => {
  return html`
    <div class="d-flex">
      ${ctx.groups.map((group, index) => until(renderGroup(group, index, ctx, html)))}
    </div>
  `;
};
